import React, { useContext } from "react";
import { Link } from "react-router-dom";
import contactContext from "../../context/contact/contactcontext";
import landingContext from "../../context/landing/landingcontext";
import "./Footer.css";

function Footer() {
  const { contactInfo } = useContext(contactContext);
  const { landingContent } = useContext(landingContext);

  const address = contactInfo && contactInfo.address ? JSON.parse(contactInfo.address) : {};
  const email = contactInfo && contactInfo.email ? JSON.parse(contactInfo.email) : {};
  const phone = contactInfo && contactInfo.phone ? JSON.parse(contactInfo.phone) : {};

  const displayPhone = phone.phone || "080 2334 7276";
  const displayEmail = email.email || "lakshmimaternityhome@gmail.com";
  const displayAddress = address.address || "95 & 96, Margosa Road, Opposite Malleswaram Exchange, Malleswaram, Bangalore";

  return (
    <footer className="foot">
      <div className="wrap">
        <div className="foot-grid">
          {/* Brand & Address */}
          <div className="foot-brand-col">
            <Link to="/">
              <img
                className="logo"
                src="/img/logo.png"
                alt="Lakshmi Maternity and Surgical Centre"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/img/uplaods/logo-foot.png";
                }}
              />
            </Link>
            <p className="addr">{displayAddress}</p>
            <div className="foot-direct-contact">
              <a href={`tel:${displayPhone.replace(/\s+/g, '')}`} className="foot-phone-link">
                <strong>Call:</strong> {displayPhone}
              </a>
              <a href={`mailto:${displayEmail}`} className="foot-email-link">
                <strong>Email:</strong> {displayEmail}
              </a>
            </div>
          </div>

          {/* Explore Links */}
          <div>
            <h4>Explore</h4>
            <ul>
              <li><Link to="/#top">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/doctors">Doctors</Link></li>
              <li><Link to="/blogs">Insights &amp; Articles</Link></li>
              <li><Link to="/contact">Contact &amp; Location</Link></li>
              <li><Link to="/appointment">Book Appointment</Link></li>
            </ul>
          </div>

          {/* Medical Services */}
          <div>
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services/gynaecology">Gynaecology &amp; Maternity</Link></li>
              <li><Link to="/services/pediatric">Paediatrics &amp; Child Care</Link></li>
              <li><Link to="/services/general-services">General &amp; Day Care Surgery</Link></li>
              <li><Link to="/services/gynaecology#normal-delivery">Normal Delivery Care</Link></li>
              <li><Link to="/services/gynaecology#laparoscopy">Laparoscopic Surgery</Link></li>
              <li><Link to="/services/pediatric#vaccination">Childhood Vaccination</Link></li>
            </ul>
          </div>

          {/* Follow Us & Social Media */}
          <div>
            <h4>Follow Us</h4>
            <ul className="foot-social-list">
              <li>
                <a
                  href="https://www.instagram.com/lakshmimaternitysurgicalcenter/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="5"/>
                    <circle cx="12" cy="12" r="4"/>
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                  </svg>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/Lakshmimaternityhospital/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCyRqaGN2QxNHqrKOlD-3Gbw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  YouTube
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/lakshmi-maternity-surgical-center/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2zM4 2a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"/>
                  </svg>
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/LMaternityBLR"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                  X (Twitter)
                </a>
              </li>
              <li>
                <a
                  href="https://g.page/r/CTYsAYWjLe53EAE/review"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  Google Reviews (4.8 ★)
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=Lakshmi+Maternity+%26+Surgical+Centre,+Margosa+Road,+Malleswaram,+Bangalore"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="foot-social-item"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                  Get Directions
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="foot-bottom">
          <span>&copy; {new Date().getFullYear()} {landingContent && landingContent.organization_name ? landingContent.organization_name : "Lakshmi Maternity & Surgical Centre"} — All rights reserved.</span>
          <span className="spacer"></span>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
